"use client"

import { useState } from "react"
import "./SoftwareReimagine.css"
import { Link } from "react-router-dom"

const cards = [
  {
    id: 1,
    title: "FINTECH",
    desc: "Fintech Solution Hero Section Background ImageCraft tailored financial applications for digital transformation with us, including web and mobile trading platforms, retail banking, investment solutions, and stock exchange apps.",
    bg: "/images/fintech.webp?height=400&width=300",
  },
  {
    id: 2,
    title: "ENERGY",
    desc: "Solar PanelsPropel your energy sector into the future, from smart grid implementations to renewable energy management. We help you pave the way for a sustainable and tech-forward energy landscape.",
    bg: "/energy.avif?height=400&width=300",
  },
  {
    id: 3,
    title: "PRODUCTIZATION",
    desc: "Team workingTransform your innovative ideas into market-ready, scalable offerings. From conceptualization to streamlined production, we guide you through every step of the productization journey.",
    bg: "/productization.avif?height=400&width=300",
  },
  {
    id: 4,
    title: "LEGALTECH",
    desc: "Whether you are focused on contract management, legal research, or case management, our software solutions provide comprehensive tools to meet your specific needs.",
    bg: "/legaltech.webp?height=400&width=300",
  },
  {
    id: 5,
    title: "PROPTECH",
    desc: "A transformative force shaping the future of property, construction, and real estate. By embracing these advancements, you can gain a competitive edge and unlock new opportunities in this dynamic market.",
    bg: "/proptech.webp?height=400&width=300",
  },
  {
    id: 6,
    title: "HEALTHTECH",
    desc: "By embracing digital transformation in your healthcare practice, you're not only catering to the changing preferences of your existing patients but also positioning yourself to attract new ones.",
    bg: "/images/healthcare.webp?height=400&width=300",
  },
]

const SoftwareReimagine = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const totalSlides = 2

  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex)
  }

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides)
  }

  // Get cards for current slide (3 cards per slide)
  const getCurrentSlideCards = () => {
    const startIndex = currentSlide * 3
    return cards.slice(startIndex, startIndex + 3)
  }

  return (
    <section className="software-reimagine-section">
      <div className="container">
      <div className="software-reimagine-header">
        <h2>
          WE HELP <span className="blue">REIMAGINE INDUSTRIES</span>
        </h2>
        <p>
          Since 2010, we’ve accelerated more than 300 web, software, and mobile application services. Leveraging our vertical expertise, we help our clients invest strategically in digital capabilities to improve their competitive advantage.
        </p>
      </div>

      <div className="carousel-container">
        <div className="software-reimagine-cards-container">
          {getCurrentSlideCards().map((card) => (
            <div
              className="software-reimagine-card"
              key={card.id}
              style={{
                backgroundImage: `url(${card.bg})`,
              }}
            >
              <div className="card-overlay38">
                <h3 className="card-title38">{card.title}</h3>
                <div className="card-hover-content">
                  <p>{card.desc}</p>
                  <span className="explore-arrow">→ EXPLORE</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Dots */}
        <div className="carousel-navigation">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`nav-dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Arrow Navigation */}
        <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide}>
          ‹
        </button>
        <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide}>
          ›
        </button>
      </div>

      <div className="software-reimagine-btn">
        <Link to="/industries">
        <button>SEE ALL INDUSTRIES</button>
        </Link>
      </div>
      </div>
    </section>
  )
}

export default SoftwareReimagine
